import { useEffect, useState } from "react";

const HtmlPreview = ({ elements, generateHTML, setGenerateHTML, setGeneratedHTML }) => {

  const [htmlCode, setHtmlCode] = useState("");

  const buildHTML = () => {

    const boxes = elements.filter(el => el.type === "box");

    let currentLeft = 0;
    const gap = 40;

    const bannerElements = boxes.map(box => {

      const boxStyle = `
      position:absolute;
      left:${currentLeft}px;
      top:0px;
      width:${box.width}px;
      height:${box.height}px;
      background:${box.background || "transparent"};
      background-image:${box.backgroundImage ? `url(${box.backgroundImage})` : "none"};
      background-size:cover;
      background-position:center;
      border-radius:${box.borderRadius || 0}px;
      padding:${box.padding || 0}px;
      z-index:${box.zIndex || 1};
      overflow:hidden;
      `;

      currentLeft += box.width + gap;

      const children = elements.filter(el => el.parentBox === box.id);

      const childrenHTML = children.map(el => {

        const baseStyle = `
        position:absolute;
        left:${el.x - box.x}px;
        top:${el.y - box.y}px;
        width:${el.width}px;
        height:${el.height}px;
        border-radius:${el.borderRadius || 0}px;
        padding:${el.padding || 0}px;
        z-index:${el.zIndex || 1};
        opacity:${el.opacity ?? 1};
        transform:rotate(${el.rotation || 0}deg);
        `;

        if (el.type === "heading") {
          return `<div style="${baseStyle}display:flex;align-items:center;justify-content:center;font-size:${el.fontSize};color:${el.color};">${el.text}</div>`;
        }

        if (el.type === "button") {
          return `<a href="${el.link || "#"}" style="${baseStyle}display:block;text-decoration:none;">
            <button style="width:100%;height:100%;background:${el.background || "black"};color:${el.color || "white"};border:none;border-radius:${el.borderRadius || 8}px;cursor:pointer;">
            ${el.text}
            </button>
          </a>`;
        }

        if (el.type === "image") {
          return `<a href="${el.link || el.src}" style="${baseStyle}display:block;">
            <img src="${el.src}" style="width:100%;height:100%;object-fit:cover;" />
          </a>`;
        }

        return "";

      }).join("");

      return `<div style="${boxStyle}">${childrenHTML}</div>`;

    }).join("");

    const bannerWidth = currentLeft + 40;

    const fullHTML = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Banner</title>
<style>
body{
margin:0;
background:#f3f4f6;
display:flex;
justify-content:center;
align-items:center;
height:100vh;
}
.bannerrs{
position:relative;

width:${bannerWidth}px;
height:300px;
border-radius:12px;
}
</style>
</head>
<body>
<div class="bannerrs">
${bannerElements}
</div>
</body>
</html>
`;

    const oneLineHTML = fullHTML
      .replace(/\n/g, "")
      .replace(/\s+/g, " ");

    setHtmlCode(oneLineHTML);
    navigator.clipboard.writeText(oneLineHTML);

    if (setGeneratedHTML) {
      setGeneratedHTML(oneLineHTML);
    }

  };

  useEffect(() => {

    if (!generateHTML) return;

    buildHTML();
    setGenerateHTML(false);

  }, [generateHTML]);

  return null;

};

export default HtmlPreview;